module.exports = __webpack_public_path__ + "1538a43d6b3b71f3649520e81acb5508.pdf";